export enum eTab {
  SOURCE_DESTINATION = 'source-destination',
  CAR_INTERGRATED = 'car-route',
  LINES = 'lines',
  INTER_CITY_LINE = 'inter-city',
  STATIONS = 'stations',
}
